var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 150 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#e87722",
    height: 85,
    strokeWidth: 0,
    width: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.36,25.93c.58,0,1.08.5,1.08,1.01v22.9c0,.65-.36,1.3-.86,1.73-4.32,3.67-10.94,5.83-17.86,5.83-15.55,0-25.92-10.37-25.92-25.92S19.17,5.56,34.72,5.56c5.33,0,10.94,1.58,15.12,4.18.58.29.79.86.65,1.3l-3.6,10.58c-.22.5-.72.72-1.37.58-2.95-1.58-6.77-2.52-10.37-2.52-6.62,0-11.09,4.75-11.09,11.81s4.46,11.95,11.09,11.95c2.66,0,4.46-.5,5.26-1.37v-4.18h-6.62c-.65,0-1.08-.29-1.15-.79l-.94-9.94c-.07-.72.36-1.22,1.15-1.22h19.51v-.01ZM40.84,40.98v.29-.29Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,52c.22.51-.07,1.01-.65,1.3-4.18,2.59-9.79,4.18-15.12,4.18-14.83,0-24.77-10.37-24.77-25.92s9.94-25.92,24.77-25.92c5.33,0,10.94,1.58,15.12,4.18.58.29.86.79.65,1.3l-4.75,10.01c-.29.65-.79.86-1.37.58-2.66-1.51-5.26-2.02-8.35-2.02-6.48,0-10.8,4.75-10.8,11.88s4.32,11.88,10.8,11.88c3.1,0,5.69-.5,8.35-2.02.58-.29,1.08-.07,1.37.58l4.75,10.01h0v-.02Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,6.71c9.43,0,15.7,5.62,15.7,14.04,0,5.18-2.52,9-6.41,10.15,4.54,1.15,7.49,5.47,7.49,11.45,0,8.42-6.26,14.04-15.62,14.04h-22.83c-.57,0-1.01-.5-1.01-1.01V7.79c0-.5.43-1.08,1.01-1.08h21.68-.01ZM121.05,26.22c2.16,0,3.6-1.3,3.6-3.31s-1.44-3.31-3.6-3.31h-4.54v6.62s4.54,0,4.54,0ZM122.34,43.5c2.09,0,3.53-1.37,3.53-3.46s-1.44-3.46-3.53-3.46h-5.83v6.91h5.83v.01Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.52,77.29c.05.09,0,.22-.11.31-.97.61-2.31,1.03-3.33,1.03-3.26,0-5.42-2.09-5.42-5.22s2.16-5.22,5.42-5.22c1.03,0,2.36.41,3.33,1.03.11.09.16.22.11.31l-1.04,2.2c-.07.14-.2.2-.32.11-.45-.32-1.13-.54-1.73-.54-1.31,0-2.18.85-2.18,2.12s.86,2.12,2.18,2.12c.59,0,1.28-.22,1.73-.54.13-.09.25-.04.32.11l1.04,2.2h0v-.02Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.88,77.33c.04.13,0,.2-.13.27-.96.63-2.34,1.01-3.73,1.01-3.19,0-5.31-2.09-5.31-5.2s2.09-5.22,5.22-5.22,4.75,1.93,4.75,5.2c0,.27-.02.54-.07.81-.02.14-.11.22-.27.22h-5.78s0,1.13,1.51,1.13c.92,0,1.94-.22,2.76-.59.13-.05.23.02.27.14l.77,2.23h.01ZM41.11,72.52c0-.79-.49-1.31-1.21-1.31-.81,0-1.35.52-1.35,1.31,0,0,2.56,0,2.56,0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,68.43c.14,0,.25.11.25.25v2.34c0,.14-.11.25-.25.25h-.47c-.68,0-1.3.31-1.53.76v6.03c0,.14-.13.27-.27.27h-3.17c-.14,0-.27-.13-.27-.27v-9.36c0-.13.13-.25.27-.25h2.03c.14,0,.23.13.29.27l.27.79c.54-.67,1.42-1.08,2.38-1.08,0,0,.47,0,.47,0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,68.43c.16,0,.27.11.27.25l-.2,1.75c-.02.14-.13.27-.27.27h-1.15v7.36c0,.14-.13.27-.27.27h-3.17c-.14,0-.27-.13-.27-.27v-7.36h-1.03c-.13,0-.25-.11-.25-.25v-1.75c0-.16.13-.27.25-.27h1.03v-1.96c0-.13.13-.23.27-.25l3.17-.31c.14-.02.27.13.27.25v2.27h1.35Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.98,78.59c-.95,0-1.58-.59-1.58-1.48s.63-1.51,1.58-1.51,1.58.61,1.58,1.51-.63,1.48-1.58,1.48Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.87,77.04c-.29.58-1.15.95-2.16.95-2.63,0-4.38-1.89-4.38-4.74,0-3.19,1.62-5.08,4.38-5.08,1.39,0,2.49.38,2.95,1.03l.32-.5c.11-.16.27-.27.42-.27h1.91c.16,0,.27.11.27.27v8.71c0,2.72-2.47,4.54-5.53,4.54-1.78,0-3.37-.41-4.25-1.13-.11-.09-.14-.22-.11-.31l.92-2.23c.05-.13.16-.18.27-.11.77.63,1.96,1.01,3.17,1.01,1.13,0,1.82-.6,1.82-1.62v-.52h0ZM69.87,72.36s-.27-.81-1.24-.81c-.9,0-1.42.63-1.42,1.71s.52,1.73,1.42,1.73c.97,0,1.24-.81,1.24-.81v-1.82Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,77.29c.05.09,0,.22-.11.31-.97.61-2.31,1.03-3.33,1.03-3.26,0-5.42-2.09-5.42-5.22s2.16-5.22,5.42-5.22c1.03,0,2.36.41,3.33,1.03.11.09.16.22.11.31l-1.04,2.2c-.07.14-.2.2-.32.11-.45-.32-1.14-.54-1.73-.54-1.31,0-2.18.85-2.18,2.12s.86,2.12,2.18,2.12c.59,0,1.28-.22,1.73-.54.13-.09.25-.04.32.11l1.04,2.2h0v-.02Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,68.86c.54-.43,1.35-.68,2.2-.68,2.85,0,4.75,2.09,4.75,5.2s-1.91,5.22-4.75,5.22c-1.21,0-2.36-.47-3.04-1.19l-.27.65c-.07.16-.16.27-.29.27h-2.04c-.14,0-.27-.13-.27-.27v-12.53c0-.13.13-.25.27-.25h3.17c.14,0,.27.13.27.25,0,0,0,3.33,0,3.33ZM88.18,74.54c.22.59.79.99,1.42.99.99,0,1.66-.86,1.66-2.16s-.67-2.09-1.66-2.09c-.63,0-1.21.4-1.42.99v2.27Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.48,78.59c-.95,0-1.58-.59-1.58-1.48s.63-1.51,1.58-1.51,1.58.61,1.58,1.51-.63,1.48-1.58,1.48Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,77.29c.05.09,0,.22-.11.31-.97.61-2.31,1.03-3.33,1.03-3.26,0-5.42-2.09-5.42-5.22s2.16-5.22,5.42-5.22c1.03,0,2.36.41,3.33,1.03.11.09.16.22.11.31l-1.04,2.2c-.07.14-.2.2-.32.11-.45-.32-1.13-.54-1.73-.54-1.31,0-2.18.85-2.18,2.12s.86,2.12,2.18,2.12c.6,0,1.28-.22,1.73-.54.13-.09.25-.04.32.11l1.04,2.2h0v-.02Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,68.43c.14,0,.23.13.18.25l-2.93,9.4c-.04.13-.18.25-.32.25h-2.79c-.14,0-.31-.13-.36-.25l-1.39-4.79-1.39,4.79c-.05.13-.22.25-.36.25h-2.79c-.14,0-.29-.13-.32-.25l-2.93-9.4c-.05-.13.04-.25.18-.25h3.64c.16,0,.31.11.34.25l.94,3.94.97-3.94c.04-.18.2-.25.32-.25h2.81c.27,0,.29.07.32.25l.97,3.94.94-3.94c.04-.14.18-.25.34-.25h3.64-.01Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGcb);
export default __webpack_public_path__ + "static/media/logo-gcb.5943a463f710051f87c33fb9cd8930c9.svg";
export { ForwardRef as ReactComponent };